<template>
    <lasting-dosage-row v-if="isLastingDosage" :dosage-choice="dosageChoice" />
    <dosage-repeat-row v-else-if="isDosageRepeat" :dosage-choice="dosageChoice" />
    <td v-else colspan="3">???</td>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from 'vue';
import { LastingDosage } from '@/service/models/common/query-dosage/dosage-choices/lasting-dosage';
import { BaseDosageChoice, DosageRepeat } from '@/service/models/common/query-dosage/dosage-choices';
import DosageRepeatRow from './DosageRepeatRow.vue';
import LastingDosageRow from './LastingDosageRow.vue';

export default defineComponent({
    components: {
        DosageRepeatRow,
        LastingDosageRow,
    },

    props: {
        dosageChoice: {
            type: Object as PropType<BaseDosageChoice>,
            required: true,
        },
    },

    setup(props)
    {
        const isDosageRepeat = computed(() => props.dosageChoice instanceof DosageRepeat);
        const isLastingDosage = computed(() => props.dosageChoice instanceof LastingDosage);

        return {
            isDosageRepeat,
            isLastingDosage,
        };
    },
})
</script>

